module.exports = __webpack_public_path__ + "static/img/Air-Freight.40efac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Air-Freight.png
// module id = N/Op
// module chunks = 1